import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const WestIndia = () => {
  return (
    <div>
      <div className="offices_div1">
        <div className="offices_div11">
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Ebony+Business+Center/@23.0128844,72.5087737,17z/data=!3m1!4b1!4m5!3m4!1s0x395e9b53959747b5:0xc17c352df3502a8e!8m2!3d23.0128916!4d72.511044?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Ebony+Business+Center/@23.0128844,72.5087737,17z/data=!3m1!4b1!4m5!3m4!1s0x395e9b53959747b5:0xc17c352df3502a8e!8m2!3d23.0128916!4d72.511044?coh=164777&entry=tt&shorturl=1"
              >
                Ahmedabad, Gujarat
              </a>
              <p>
                B-801, Safal Pegasus, 100 ft Prahlad Nagar Road, <br />
                Near Auda Garden, Anandnagar, <br />
                Ahmedabad, <br /> Gujarat - 380 007 <br />
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Skyline+Icon/@19.1054471,72.8789893,17z/data=!3m1!4b1!4m5!3m4!1s0x3be7c86c7fbfffff:0x3bccee2733950c9e!8m2!3d19.105442!4d72.881178?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Skyline+Icon/@19.1054471,72.8789893,17z/data=!3m1!4b1!4m5!3m4!1s0x3be7c86c7fbfffff:0x3bccee2733950c9e!8m2!3d19.105442!4d72.881178?coh=164777&entry=tt&shorturl=1"
              >
                Mumbai, Maharashtra
              </a>
              <p>
                7th Floor, Skyline Icon, Andheri - Kurla Rd, Chimatpada,
                <br /> Marol, Andheri East, Mumbai, <br />
                Maharashtra - 400 059
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Aundh+IT+Park,+PUNE+IT+PARK,+Bhau+Patil+Rd,+Pragati+Nagar,+Bopodi,+Pune,+Maharashtra+411020/@18.5668373,73.8284772,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2bf4e1c72e6af:0x609914aa386d239b!8m2!3d18.5668373!4d73.8284772!16s%2Fg%2F1tfr_j3g?entry=ttu"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Aundh+IT+Park,+PUNE+IT+PARK,+Bhau+Patil+Rd,+Pragati+Nagar,+Bopodi,+Pune,+Maharashtra+411020/@18.5668373,73.8284772,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2bf4e1c72e6af:0x609914aa386d239b!8m2!3d18.5668373!4d73.8284772!16s%2Fg%2F1tfr_j3g?entry=ttu"
              >
                Pune, Maharashtra
              </a>
              <p>
                C/203/8, Pune IT Park, <br />
                34 Aundh Road, Bhau Patil Marg, <br />
                Pune,<br /> Maharashtra - 411 020 <br />
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/SPACEPLEXX+Coworking+space+%7C+Coworking+space+in+Surat/@21.1490413,72.7737337,17z/data=!3m1!4b1!4m5!3m4!1s0x3be05270f1fbfb61:0x8eea046ddcacee68!8m2!3d21.1490363!4d72.7759224?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/SPACEPLEXX+Coworking+space+%7C+Coworking+space+in+Surat/@21.1490413,72.7737337,17z/data=!3m1!4b1!4m5!3m4!1s0x3be05270f1fbfb61:0x8eea046ddcacee68!8m2!3d21.1490363!4d72.7759224?coh=164777&entry=tt&shorturl=1"
              >
                Surat, Gujarat
              </a>
              <p>
                205, SNS Plantina, Opposite Shrenik Residency, Near <br />{" "}
                Reliance Market Vesa, Surat,<br /> Gujarat - 395 007
              </p>
            </div>
          </div>
        </div>
        <div className="offices_div11">
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/AAKASHDEEP+COMPLEX/@22.7008718,75.868866,17z/data=!3m1!4b1!4m6!3m5!1s0x3962fd1df643e94f:0x282ba89cbfa0eb2!8m2!3d22.7008718!4d75.868866!16s%2Fg%2F11bbt9kt2q?entry=ttu"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/AAKASHDEEP+COMPLEX/@22.7008718,75.868866,17z/data=!3m1!4b1!4m6!3m5!1s0x3962fd1df643e94f:0x282ba89cbfa0eb2!8m2!3d22.7008718!4d75.868866!16s%2Fg%2F11bbt9kt2q?entry=ttu"
              >
                Indore, Madhya Pradesh
              </a>
              <p>
                M6, Akashdeep Complex, 21 <br />
                Sneh Nagar, Indore, <br />
                Madhya Pradesh - 452 001 <br />
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a target="_blank" href="">
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a target="_blank" href="">
                Panaji, Goa
              </a>
              <p>
                Office No.1-B, 2nd Floor, Grace Avenue, Adjacent to <br />{" "}
                Bicholim Bus Stand, <br />Bicholim, Goa - 403 503
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a target="_blank" href="">
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a target="_blank" href="">
                Raipur, Chhatisgarh
              </a>
              <p>
                Space Entrepreneurship Center Pvt. Ltd. C MIG-29, <br />{" "}
                Indravati Colony, Off Canal Linking, Raipur, <br />Chhattisgarh
                - 492 001
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WestIndia;
